import {Component, Input} from '@angular/core';

/**
 * Generated class for the HelpComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'help',
  templateUrl: 'help.html'
})
export class HelpComponent {

  @Input() id: string;
  text: string;

  constructor() {
    console.log('Hello HelpComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/help/help.ts